export interface PinCell {
  x: number;
  y: number;
}

const CARD_W = 0.12;
const CARD_H = 0.085;
const GAP = 0.02;

export const pinLayout = (count: number): PinCell[] => {
  if (count <= 0) return [];
  const cols = Math.ceil(Math.sqrt(count));
  const rows = Math.ceil(count / cols);
  const stepX = CARD_W + GAP;
  const stepY = CARD_H + GAP;
  const cells: PinCell[] = [];
  for (let i = 0; i < count; i += 1) {
    const col = i % cols;
    const row = Math.floor(i / cols);
    const x = (col - (cols - 1) / 2) * stepX;
    const y = ((rows - 1) / 2 - row) * stepY;
    cells.push({ x, y });
  }
  return cells;
};

export const CARD_SIZE = { w: CARD_W, h: CARD_H };
